import type { BillingFigure } from "@/lib/billingTotals";

/** Known per-currency amounts and notes under a billing figure's headline value. */
export function BillingFigureDetail({ figure }: { figure: BillingFigure }) {
  if (figure.parts.length === 0 && figure.notes.length === 0) return null;
  return (
    <div className="flex min-w-0 flex-col gap-0.5 text-xs font-normal text-muted-foreground [overflow-wrap:anywhere]">
      {figure.parts.length > 0 && (
        <div className="flex flex-wrap gap-x-3 font-medium text-foreground tabular-nums">
          {figure.parts.map((p) => <span key={p}>{p}</span>)}
        </div>
      )}
      {figure.notes.map((n) => <div key={n}>{n}</div>)}
    </div>
  );
}
